import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

const brandDataShape = (form) => {
    let formData = new FormData();
    formData.append('name', form.name);
    formData.append('slug', form.slug);
    formData.append('language_id', form.language_id);
    if (form.description != null && form.description.trim() !== '') formData.append('description', form.description);
    return formData;
}

const reshapeForm = (form) => {
    let baseSubscription = Object.assign({}, form)
    baseSubscription.form_subscription = JSON.stringify(baseSubscription.form_subscription)
    return baseSubscription
}

export default {
    namespaced: true,
    state: {

        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        getUserSubscriptions({commit, state}, form) {
            let req = axios.get(`/subscription/users/${form.user_id}?page=${form.page}`)
            return req
        },
        getRelatedSubscriptions({commit, state}, form) {
            let req = axios.get(`/subscription-charge/${form.subscription_charge_id}`)
            return req
        },
        chargeSubscription({commit, state}, form) {
            let req = axios.get(`/pay/subscription/user/${form.user}/subscription-charge/${form.subscriptionCharge}/product/${form.product}?gateway=${form.gateway}`)
            return req
        },
        updateSubscription({commit, state}, form) {
            let req = axios.post(`subscription-plan/update/${form.id}`, form)
            req.then(res => {
                const data = res.data.data;

            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        creatSubscription({commit, state}, form) {
            let req = axios.post(`subscription-plan/store`, form)
            req.then(res => {
                const data = res.data.data;

            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        getSubscriptions({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/subscription-plan?page=${page}&${query}`)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        getSubscription({commit, state}, form) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/subscription-plan/${form.id}`)
            req.then(res => {
                const data = res.data.data;
            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        deleteSubscription({commit, state}, form) {
            let req = axios.get(`subscription-plan/destroy/${form.id}`)

            return req
        },
        creatSubscriptionItem({commit, state}, form) {
            let req = axios.post(`subscription-items/create/${form.subscription_id}`, form)
            req.then(res => {
                const data = res.data.data;

            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        deleteSubscriptionItem({commit, state}, form) {
            let req = axios.delete(`subscription-items/destroy/${form.id}`)

            return req
        },
        updateSubscriptionItem({commit, state}, form) {
            let req = axios.post(`subscription-items/update/${form.id}`, form)
            req.then(res => {
                const data = res.data.data;

            })
                .catch(error => {
                    console.log(error)
                })
            return req
        },
        addSubscriptionToProduct({commit, state}, form) {
            let req = axios.post(`subscription-plan/add/product/${form.product_id}/subscription-item/${form.subscription_item_id}`, form)
            return req
        },
        deleteProductSubscription({commit, state}, form) {
            let req = axios.get(`subscription-plan/delete/product-subscriptions/${form.id}`)
            return req
        },
        getProductSubscriptions({commit, state}, form) {
            let req = axios.get(`subscription-plan/product/${form.id}`)
            return req
        }

    },
    getters: {
        getFilters: (state) => state.filters,
    }
}